import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

// Display helper: title-case a name stored in all-caps (migration data) so it
// reads as a name, not a shout. "CAMILI MAYORGA CARRILLO" → "Camili Mayorga
// Carrillo". Only changes presentation; the stored value is untouched.
export function toTitleCase(value: string): string {
  return value
    .toLocaleLowerCase()
    .replace(/(^|[\s'’\-/.])(\p{L})/gu, (_m, sep: string, ch: string) => sep + ch.toLocaleUpperCase())
}

const moneyFormatter = new Intl.NumberFormat("es-EC", {
  style: "currency",
  currency: "USD",
})

// Format an amount (number or Prisma Decimal-as-string) as USD — Ecuador's
// currency. "120" → "$120.00".
export function formatMoney(amount: number | string | null | undefined): string {
  const n = typeof amount === "string" ? Number(amount) : (amount ?? 0)
  return moneyFormatter.format(Number.isFinite(n) ? n : 0)
}
